import { CatalogSectionCount } from '../../../catalog.types';
import { ResolveOptimisticSectionOrderParams } from './resolveOptimisticSectionOrder.types';

export const resolveOptimisticSectionOrder = ({
  sections,
  optimisticIds,
}: ResolveOptimisticSectionOrderParams): CatalogSectionCount[] => {
  if (!optimisticIds) {
    return sections;
  }

  const sectionById = new Map(sections.map((section) => [section.catalogSectionId, section]));
  const orderedIds = new Set(optimisticIds);

  const ordered = optimisticIds
    .map((id) => sectionById.get(id))
    .filter((section): section is CatalogSectionCount => section !== undefined);
  const notYetOrdered = sections.filter((section) => !orderedIds.has(section.catalogSectionId));

  return [...ordered, ...notYetOrdered];
};
